<script lang="ts">

    import { fly, fade } from 'svelte/transition';
    import { bounceOut } from 'svelte/easing';

    export let title: string;

</script>

<div class="award-title">
    {#each title as letter, index}
        <span
            in:fly={{ y: -100, delay: 100 * (1 + index), easing: bounceOut }}
            out:fade
            class="letter">{letter}</span>
    {/each}
</div>

<style lang="scss">

    .award-title {
        font-family: ManagerButton;
        font-size: 7vw;
        color: var(--color-secondary);
        text-align: center;
    }

    .letter {
        display: inline-block;
    }

</style>
